
import moment from 'moment'
import React from 'react'
import { connect } from 'react-redux'

import { withLegacyRouter } from '../../../../../decorators'
import { mapGoal, unmapGoal } from '../../../../../lib/Proxy/goal'
import { IGAO } from '../../../../igao'
import * as Card from '../../../../shared/card'
import CrudTable from '../../../../shared/CrudTable'
import FriendlyDate from '../../../../shared/Date/FriendlyDate'
import ConfirmationDeleteDialog from '../../../../shared/DeleteDialog/ConfirmationDeleteDialog'

import GoalForm from './components/form'

const mkSpec = patientId => ({
  type: 'goal',
  form: GoalForm,
  urls: {
    get: () =>
      `/patients/${patientId}/fhir/Goal?patient=Patient/${patientId}&category=160786009&_count=99999`,
    create: () => `/patients/${patientId}/fhir/Goal`,
    update: entry => `/patients/${patientId}/fhir/Goal/${entry.id}`,
    delete: entry => `/patients/${patientId}/fhir/Goal/${entry.id}`
  },
  mapFns: {
    toForm: unmapGoal,
    toFhir: entry => mapGoal(patientId, entry)
  },
  table: [
    {
      title: 'Goal',
      displayFn: x => x.goal
    },
    {
      title: 'Location',
      displayFn: x => x.location
    },
    {
      title: 'Date',
      displayFn: x => (
        <FriendlyDate
          date={
            (typeof x.date === 'string' && x.date) ||
            (typeof x.date === 'object' &&
              moment(x.date).format('MM/DD/YYYY')) ||
          ''
          }
        />
      ),
      sortBy: 'date'
    }
  ]
})

function GoalGrid (props) {
  const { params, patientId } = props
  const ptId = params ? params.id : patientId
  const spec = mkSpec(ptId)

  return (
    <div className='main'>
      <Card.Card>
        <Card.Header>
          <h2>Goals</h2>
        </Card.Header>
        <div style={{ padding: '0 1rem 1rem' }}>
          <CrudTable
            labelButton='Goal'
            labelNoEntries='Goals'
            urlFns={spec.urls}
            entryType={spec.type}
            entrySet={patientId}
            tableDefinition={spec.table}
            mapFns={spec.mapFns}
            form={spec.form}
            deleteDialog={ConfirmationDeleteDialog}
          />
        </div>
      </Card.Card>
      <IGAO path='goals' />
    </div>
  )
}

const mapStateToProps = redux => {
  const patientId = redux?.globalVars?.params?.id
  return {
    patientId
  }
}

const mapDispatchToProps = dispatch => ({
  dispatch
})

export default connect(mapStateToProps, mapDispatchToProps)(withLegacyRouter(GoalGrid))
